import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col relative" }
const _hoisted_2 = { class: "mt-40" }
const _hoisted_3 = { class: "flex flex-wrap md:flex-nowrap" }
const _hoisted_4 = { class: "w-full flex flex-row-reverse md:flex-row" }
const _hoisted_5 = { class: "mb-20" }
const _hoisted_6 = { class: "md:w-full md:flex md:flex-row" }
const _hoisted_7 = { class: "flex-1 md:pr-30" }
const _hoisted_8 = { class: "hidden pr-40 lg:block lg:pr-60 xl:pr-80" }
const _hoisted_9 = { class: "mt-20 mb-40 w-full ml-auto md:w-1/3 md:mt-0 md:flex md:flex-col md:pt-38 xl:pt-46" }
const _hoisted_10 = { class: "md:ml-auto md:h-full md:flex md:flex-col md:justify-start" }
const _hoisted_11 = { class: "flex mt-20 w-auto flex-row-reverse md:flex-col justify-between md:mt-10" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PDPLink = _resolveComponent("PDPLink")!
  const _component_ProductSpecs = _resolveComponent("ProductSpecs")!
  const _component_RegularItemImage = _resolveComponent("RegularItemImage")!
  const _component_RegularItemQuantity = _resolveComponent("RegularItemQuantity")!
  const _component_RegularItemPrice = _resolveComponent("RegularItemPrice")!
  const _component_AddOfferItemToBasket = _resolveComponent("AddOfferItemToBasket")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", {
            class: _normalizeClass(["flex-1", {'opacity-35': _ctx.item.variant.isDiscontinued}])
          }, [
            _createElementVNode("p", _hoisted_5, [
              _createVNode(_component_PDPLink, {
                sku: _ctx.item.variant.sku,
                title: _ctx.item.variant.name,
                disabled: _ctx.item.variant.isDiscontinued,
                class: _normalizeClass([{'c-magic-line': !_ctx.item.variant.isDiscontinued}, "o-text-h4"])
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.item.variant.name), 1)
                ]),
                _: 1
              }, 8, ["sku", "title", "disabled", "class"])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_ProductSpecs, {
                  variant: _ctx.item.variant,
                  "show-unit-info": false
                }, null, 8, ["variant"])
              ]),
              _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$dictionary.format(_ctx.labels.lineItemQuantityShort, [_ctx.item.quantity])), 1)
            ])
          ], 2),
          _createVNode(_component_PDPLink, {
            sku: _ctx.item.variant.sku,
            title: _ctx.item.variant.name,
            disabled: _ctx.item.variant.isDiscontinued,
            class: "relative w-1/3 mt-10 pr-15 sm:pr-20 md:order-first md:pr-35 lg:w-1/4"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_RegularItemImage, {
                variant: _ctx.item.variant
              }, null, 8, ["variant"])
            ]),
            _: 1
          }, 8, ["sku", "title", "disabled"])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", {
              class: _normalizeClass([{'opacity-35': _ctx.item.variant.isDiscontinued}, "w-2/3 ml-auto sm:w-220 sm:ml-auto md:ml-0 md:w-auto"])
            }, [
              _createVNode(_component_RegularItemQuantity, {
                quantity: _ctx.item.quantity,
                class: "mb-7 lg:hidden"
              }, null, 8, ["quantity"]),
              (_ctx.item.price)
                ? (_openBlock(), _createBlock(_component_RegularItemPrice, {
                    key: 0,
                    price: _ctx.item.price,
                    quantity: _ctx.item.quantity,
                    class: "min-w-200 lg:min-w-250"
                  }, null, 8, ["price", "quantity"]))
                : _createCommentVNode("", true)
            ], 2),
            _createElementVNode("div", _hoisted_11, [
              (!_ctx.item.variant.isDiscontinued)
                ? (_openBlock(), _createBlock(_component_AddOfferItemToBasket, {
                    key: 0,
                    "line-item-id": _ctx.item.id,
                    "button-text": _ctx.labels.lineItemAddToBasket,
                    class: "w-2/3 sm:w-220 md:w-300 lg:ml-auto"
                  }, null, 8, ["line-item-id", "button-text"]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ])
  ]))
}